import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface PaymentForm {
  documentOwner: string;
  id: number;
  description: string;
  numberInstallments: number;
  interest: number;
  dayFirstQuote: number;
}

interface PaymentFormsState {
  paymentForms: PaymentForm[];
  isLoading: boolean;
  error: string | null;
}

const initialState: PaymentFormsState = {
  paymentForms: [],
  isLoading: false,
  error: null,
};

const paymentFormsSlice = createSlice({
  name: "paymentForms",
  initialState,
  reducers: {
    setPaymentForms(state, action: PayloadAction<PaymentForm[]>) {
      state.paymentForms = action.payload;
      state.error = null;
    },
    clearPaymentForms(state) {
      state.paymentForms = [];
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setError(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.isLoading = false;
    },
    clearError(state) {
      state.error = null;
    },
  },
});

export const { setPaymentForms, clearPaymentForms, setLoading, setError, clearError } =
  paymentFormsSlice.actions;
export default paymentFormsSlice.reducer;
